import { createRouter, createWebHistory } from "vue-router";
import DashboardPage from "../components/pages/ElearningDashboardPage.vue";
import DoctorBookingsPage from "../components/pages/DoctorBookingsPage.vue";
import Rafiki360Page from "../components/pages/Rafiki360Page.vue";
import AppealsDonationsPage from "../components/pages/AppealsDonationsPage.vue";
import LoginPage from "../components/pages/LoginPage.vue";
import DefaultLayout from "../components/layouts/DefaultLayout.vue";
import store from "../store";

const routes = [
  {
    path: "/",
    redirect: "/e-learning", // Redirect root to /e-learning
  },
  {
    path: "/e-learning",
    name: "ElearningLayout",
    component: DefaultLayout,
    meta: {
      title: "E-Learning Management",
      requiresAuth: true,
      system: "eLearning",
    },
    children: [
      {
        path: "",
        name: "DashboardPage",
        component: DashboardPage,
      },
      {
        path: "dashboard/:tab?",
        name: "DashboardPageWithTab",
        component: DashboardPage,
        props: true,
        meta: {
          title: "E-Learning Management",
          requiresAuth: true,
          system: "eLearning",
        },
      },
      {
        path: "locums",
        name: "LocumsPage",
        redirect: "/e-learning/dashboard/locums",
      },
      {
        path: "discounted_users_by_course/:course_id/:course_name",
        name: "DiscountedUsersByCourse",
        component: () => import("../components/pages/CourseDiscoutedUsers.vue"),
        meta: {
          title: "Discounted Users",
          requiresAuth: true,
          system: "eLearning",
        },
        props: true,
      },
    ],
  },
  {
    path: "/doctor-bookings",
    name: "DoctorBookingsLayout",
    component: DefaultLayout,
    meta: {
      title: "Doctor Bookings Management",
      requiresAuth: true,
      system: "hmis",
    },
    children: [
      {
        path: "",
        name: "DoctorBookingsPage",
        component: DoctorBookingsPage,
      },
    ],
  },
  {
    path: "/rafiki360",
    name: "Rafiki360Layout",
    component: DefaultLayout,
    meta: {
      title: "Rafiki360 Management",
      requiresAuth: true,
      system: "rafiki360",
    },
    children: [
      {
        path: "",
        name: "Rafiki360Page",
        component: Rafiki360Page,
      },
    ],
  },
  {
    path: "/appeals-donations",
    name: "AppealsDonationsLayout",
    component: DefaultLayout,
    meta: {
      title: "Appeals & Donations",
      requiresAuth: true,
      system: "appeals",
    },
    children: [
      {
        path: "",
        name: "AppealsDonationsPage",
        component: AppealsDonationsPage,
      },
    ],
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
    meta: {
      title: "Login",
      requiresAuth: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard
router.beforeEach((to, from, next) => {
  // Special handling for login page
  if (to.path === '/login') {
    // Check if user is authenticated for any system
    const systems = ['eLearning', 'hmis', 'rafiki360', 'appeals'];
    const isAuthenticatedForAny = systems.some(system =>
      store.getters.isAuthenticated(system)
    );

    if (isAuthenticatedForAny) {
      // User is authenticated, redirect to appropriate dashboard
      const currentSystem = store.state.currentSystem || 'eLearning';
      const redirectPath = currentSystem === 'hmis'
        ? '/doctor-bookings'
        : currentSystem === 'rafiki360'
        ? '/rafiki360'
        : currentSystem === 'appeals'
        ? '/appeals-donations'
        : '/e-learning';
      next(redirectPath);
      return;
    } else {
      // User not authenticated, allow access to login
      next();
      return;
    }
  }

  // Handle redirect from root to e-learning with tab persistence
  if (to.path === '/e-learning') {
    const savedTab = localStorage.getItem('elearning_current_tab');
    if (savedTab && savedTab !== 'institutions') {
      next(`/e-learning/dashboard/${savedTab}`);
      return;
    }
  }

  // For protected routes, check authentication
  if (to.meta.requiresAuth) {
    const system = to.meta.system;
    if (!store.getters.isAuthenticated(system)) {
      store.commit("setIntendedRoute", to.fullPath);
      next(); // Allow navigation to trigger login popup
      return;
    }
  }

  // Allow navigation for all other cases
  document.title = to.meta.title || "Default Title";
  next();
});

export default router;
